var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.$store.state.user && _vm.$store.state.user.user_type==='uam')?_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('UAMProfile')],1)],1):_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('RootProfile')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }